import Loading, { LOADING_TRANSITION_DURATION } from './Loading';
import { showWithTransition } from '../../utils/show';
import { wrapWithConfigDefaults } from '../../utils/helper';
export default wrapWithConfigDefaults(function (config) {
    if (config === void 0) { config = {}; }
    return showWithTransition({
        Component: Loading,
        transitionDuration: LOADING_TRANSITION_DURATION,
        autoClose: false,
        forcedProps: { embedded: false },
        props: config,
        contexts: config.contexts,
    });
});
